import { create } from "zustand";

import { FILE_IMPORT_INITIAL_STEP } from "../constants";

const initialState = {
  successfulImports: [],
  unparsedBOMs: [],
  currentIndex: 0,
  currentStep: FILE_IMPORT_INITIAL_STEP,
  currentUnparsedBOM: null,
  headers: null,
  currentFile: null,
  uploadProgression: null,
  currency: null,
  showChooseCurrencyModal: false,
  parsingDone: false,
  parsedFinishedGood: null,
  parsedComponents: null,
  showHeaderConfirmationModal: false,
  headerValidation: { done: false, isValid: null },
  submittingToApi: false,
  matchedFinishedGoodHeaders: null,
  matchedComponentHeaders: null,
  newBomId: null,
  showFgQuestionsModal: false,
  showComponentQuestionsModal: false,
};

const useFileImportStore = create((set, get) => ({
  ...initialState,
  setSuccessfulImports: (payload) => {
    set({ successfulImports: payload });
  },
  addSuccessfulImport: (payload) => {
    set((state) => ({ successfulImports: [...state.successfulImports, payload] }));
  },
  setUnParsedBOMs: (payload) => {
    set({ unparsedBOMs: payload });
  },
  incrementBOMImportIndex: () => {
    const { unparsedBOMs, currentIndex } = get();
    const nextIdx = currentIndex + 1;
    if (unparsedBOMs.length - 1 < nextIdx) {
      return;
    }
    set({ currentIndex: nextIdx });
  },
  setCurrentBOMImportIndex: (payload) => {
    set({ currentIndex: payload });
  },
  setCurrentUnparsedBOM: (payload) => {
    set({ currentUnparsedBOM: payload });
  },
  setHeaders: (payload) => {
    set({ headers: payload });
  },
  setCurrentFile: (payload) => {
    set({ currentFile: payload });
  },
  setUploadProgression: (payload) => {
    set({ uploadProgression: payload });
  },
  setCurrency: (payload) => {
    set({ currency: payload });
  },
  setShowChooseCurrencyModal: (payload) => {
    set({ showChooseCurrencyModal: payload });
  },
  setParsingDone: (payload) => {
    set({ parsingDone: payload });
  },
  setParsedFinishedGood: (payload) => {
    set({ parsedFinishedGood: payload });
  },
  setParsedComponents: (payload) => {
    set({ parsedComponents: payload });
  },
  setShowHeaderConfirmationModal: (payload) => {
    set({ showHeaderConfirmationModal: payload });
  },
  setHeaderValidation: (payload) => {
    set({ headerValidation: payload });
  },
  setCurrentStep: (payload) => {
    set({ currentStep: payload });
  },
  setSubmittingToApi: (payload) => {
    set({ submittingToApi: payload });
  },
  setMatchedFinishedGoodHeaders: (payload) => {
    set({ matchedFinishedGoodHeaders: payload });
  },
  setMatchedComponentHeaders: (payload) => {
    set({ matchedComponentHeaders: payload });
  },
  setNewBomId: (payload) => {
    set({ newBomId: payload });
  },
  setShowFgQuestionsModal: (payload) => {
    set({ showFgQuestionsModal: payload });
  },
  setShowComponentQuestionsModal: (payload) => {
    set({ showComponentQuestionsModal: payload });
  },
  clearState: (clearAll) => {
    if (clearAll) {
      set({ ...initialState });
      return;
    }
    set((state) => {
      const retainedKeys = ["unparsedBOMs", "currentIndex", "successfulImports", "currentFile"];
      const retained = Object.fromEntries(retainedKeys.map((key) => [key, state[key]]));
      return { ...initialState, ...retained };
    });
  },
}));

export default useFileImportStore;
